import React, { useMemo } from 'react';
import ParentContainor from '../../components/base/ParentContainor';
import LeaderboardScreen from '../../components/LeaderboardScreen';
import TournamentProgressStepper, {
  DEFAULT_STAGES,
} from '../../components/TournamentProgressStepper';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';
import { TEXT_LABELS } from '../../constants/TextLabelConstants';
import { PAGE_OUTER_PADDING } from '../../constants/housieLiveStyles';
import { IMAGE_CONSTANTS } from '../../constants/ImageConstans';
import {
  getPlayerPoints,
  normalizeLeaderboardPlayer,
} from '../../utils/utils';

/**
 * TEMP preview page — tournament leaderboard design (no auth / no API).
 * Open: /preview/tournament-leaderboard
 */
const MOCK_PLAYERS = [
  {
    userId: 'p1',
    userName: 'Player B',
    totalPoints: 200000,
    roundScores: [
      {
        roundNumber: 1,
        gameTypeIcon: IMAGE_CONSTANTS.V2_TOURNAMENT_STEPPER_RAPFIRE,
        points: 90000,
      },
      {
        roundNumber: 2,
        gameTypeIcon: IMAGE_CONSTANTS.V2_TOURNAMENT_STEPPER_RAPHOUSIE,
        points: 70000,
      },
      {
        roundNumber: 3,
        gameTypeIcon: IMAGE_CONSTANTS.V2_TOURNAMENT_STEPPER_RAPFIRE,
        points: 40000,
      },
    ],
    userImage: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
  },
  {
    userId: 'p2',
    userName: 'Player A',
    score: 150000,
    userImage: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
  },
  {
    userId: 'p3',
    userName: 'Player C',
    score: 120000,
    userImage: IMAGE_CONSTANTS.V2_HEADER_LOGO || IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
  },
  {
    userId: 'p4',
    userName: 'Rubby Jain',
    score: 50000,
    userImage: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
  },
  {
    userId: 'p5',
    userName: 'QuizWarrior',
    score: 42000,
    userImage: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
  },
  {
    userId: 'p6',
    userName: 'RapStar99',
    score: 38000,
    userImage: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
  },
  {
    userId: 'p7',
    userName: 'NeonNinja',
    score: 31000,
    userImage: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
  },
  {
    userId: 'p8',
    userName: 'LuckySeven',
    score: 25000,
    userImage: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
  },
];

const rankLeaderboardPlayers = (players = []) =>
  [...players]
    .map((user) => normalizeLeaderboardPlayer(user))
    .sort((a, b) => getPlayerPoints(b) - getPlayerPoints(a))
    .map((user, index) => ({
      ...user,
      rank: index + 1,
    }));

const TournamentLeaderboardDesignPreview = () => {
  const rankedUsers = useMemo(() => rankLeaderboardPlayers(MOCK_PLAYERS), []);
  const hasWinners = rankedUsers.some((player) => getPlayerPoints(player) > 0);

  return (
    <ParentContainor
      route={ROUTE_ENUM.SELECT_GAME}
      parentContainorStyle={{ justifyContent: 'flex-start' }}
      isShowHeader={false}
      showCopyRightText
      isBreadcrumbVisible={false}
      padding={PAGE_OUTER_PADDING}
      showBlurredBg
    >
      <LeaderboardScreen
        headerTitle="Fun Friday eve."
        hideBack
        variant="tournament"
        headerExtra={<TournamentProgressStepper stages={DEFAULT_STAGES} />}
        columns={{
          rank: TEXT_LABELS.RAP_FIRE_LEADERBOARD_COL_RANK,
          player: TEXT_LABELS.RAP_FIRE_LEADERBOARD_COL_PLAYER,
          points: TEXT_LABELS.RAP_FIRE_LEADERBOARD_COL_GAME_POINTS,
          won: TEXT_LABELS.TOURNAMENT_LEADERBOARD_COL_TOTAL_POINTS,
        }}
        players={rankedUsers}
        showBoard
        hasWinners={hasWinners}
        emptyLabel={TEXT_LABELS.TOURNAMENT_LEADERBOARD_NO_WINNERS}
        congratsLabel={
          hasWinners
            ? TEXT_LABELS.TOURNAMENT_LEADERBOARD_WINNER_WISHES
            : TEXT_LABELS.TOURNAMENT_LEADERBOARD_NO_WINNERS
        }
        rewardStatus
        prizeAllotments={[
          { rankFrom: 1, rankTo: 1, prizeTitle: 'Shoes' },
          { rankFrom: 2, rankTo: 2, prizeTitle: 'Cricket Bat' },
          { rankFrom: 3, rankTo: 3, prizeTitle: 'Cricket Jersey' },
          { rankFrom: 4, rankTo: 10, prizeTitle: 'Coupons' },
        ]}
        prizeWinners={rankedUsers}
      />
    </ParentContainor>
  );
};

export default TournamentLeaderboardDesignPreview;
